export default {
  MAIN: 'MAIN',
  DETAIL: 'DETAIL',
  CATEGORY: 'CATEGORY',
  SEARCH: 'SEARCH',
  MY_ACCOUNT: 'MY_ACCOUNT',
  ONBOARDING: 'ONBOARDING',
};
